



















import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import warehouseCity from '@/store/entities/warehouse-city';
import warehouseInfo from '@/store/entities/warehouseInfo';
import appconst from '@/lib/appconst';
import Enums from '@/lib/enums'
class AddFreight {
    warehouseRemark: string;
}
@Component
export default class CreatefreightModule extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    freight: AddFreight = new AddFreight();
    selectDate: string = "";


    addLoding = false;

    created() {
 
    }
    signFor() {
        this.save();
    }
    save() {
        (this.$refs.freightCreateForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.addLoding = true;
                await this.$store.dispatch({
                    type: 'returnrejection/addWarehouseRemark',
                    data: { id: this.$store.state.returnrejection.id, remark: this.freight.warehouseRemark }
                }).finally(() => {
                    this.addLoding = false;
                });

                (this.$refs.freightCreateForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input', false);

            }
        })
    }


    cancel() {
        (this.$refs.freightCreateForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
        }
    }


}
